import { useEffect, useRef } from 'react';

export function useAudio(url: string) {
  const audio = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    audio.current = new Audio(url);
    audio.current.loop = true;

    return () => {
      audio.current?.pause();
      audio.current = null;
    };
  }, [url]);

  return audio;
}
